import { Box, Flex, Text } from '@chakra-ui/react';

import { QuantityControl } from '../../carts/QuantityControl';
import type { CardProductProps } from '../card-product/card-product';

interface ProductInfoSectionProps {
  product?: CardProductProps['product'];
  hasFractionalStep: boolean;
  inputProps: any;
  incProps: any;
  decProps: any;
  isCartTotalFetching: boolean;
  isLoading: boolean;
  available: string;
  statusColor: string;
}

export function ProductInfoSection({
  product,
  hasFractionalStep,
  inputProps,
  incProps,
  decProps,
  isCartTotalFetching,
  isLoading,
  available,
  statusColor,
}: ProductInfoSectionProps) {
  return (
    <Flex align="flex-start" mb={4} gap={3}>
      <Box
        boxSize={16}
        bg="white"
        rounded="sm"
        overflow="hidden"
        display="flex"
        alignItems="center"
        justifyContent="center"
        border="1px solid"
        borderColor="gray.200"
        flexShrink={0}
      >
        {product?.product_image_thumbnails?.[0] && (
          <img
            src={product.product_image_thumbnails[0]}
            style={{
              width: '100%',
              height: '100%',
              objectPosition: 'center',
              objectFit: 'contain',
            }}
            alt={product?.desc || 'Product image'}
          />
        )}
      </Box>
      <Box flex={1} minW={0}>
        <Text
          fontWeight="medium"
          fontSize="10px"
          noOfLines={1}
          textTransform="uppercase"
          letterSpacing="wide"
          mb={0.5}
        >
          {product?.brand_desc}
        </Text>
        <Text fontSize="xs" noOfLines={2} lineHeight="short" mb={0.5}>
          {product?.desc}
        </Text>
        {product?.item_code && (
          <Text fontSize="sm" color="gray.600" noOfLines={1} mb={2}>
            {product.item_code}
          </Text>
        )}
        <Flex align="center" justify="space-between" gap={2}>
          <Text color={statusColor} fontSize="xs" flexShrink={0}>
            {available}
          </Text>
          <Box flexShrink={0}>
            <QuantityControl
              variant="add-to-cart"
              hasFractionalStep={hasFractionalStep}
              inputProps={inputProps}
              incProps={incProps}
              decProps={decProps}
              isLoading={isCartTotalFetching || isLoading}
            />
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
}
